import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { usePocketBase } from "../PocketBaseContext";
// import { logoutUser } from "../slices/auth/login/thunk"; // Removed

const AuthProtected = ({ children }) => {
  // const dispatch = useDispatch(); // Removed
  const pb = usePocketBase();
  const [loading, setLoading] = useState(true);
  const [userProfile, setUserProfile] = useState(null);

  useEffect(() => {
    const isAuthenticated = pb.authStore.isValid;
    const user = pb.authStore.model;

    if (isAuthenticated && user) {
      setUserProfile(user);
    } else {
      // Just let it navigate to login via state check below
      // dispatch(logoutUser()); 
    }
    setLoading(false);
  }, [pb]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!userProfile) {
    return <Navigate to="/login" />;
  }

  return React.Children.map(children, child =>
    React.cloneElement(child, { userProfile: userProfile })
  );
};

export { AuthProtected };